import { useCallback, useEffect, useRef, useState } from 'react'

// Sem response (queda de rede), o security.validation rejeita com uma mensagem em HTML, feita para o SweetAlert: o bloco
// mostra texto puro
export function errorMessage(error) {
  if (!error?.response) return 'Sem resposta do servidor. Tente de novo em alguns segundos.'
  return error.response.data?.message || error?.message || 'Não foi possível carregar os dados.'
}

export function isForbidden(error) {
  return error?.response?.status === 403
}

// Um bloco do Dashboard: { loading, error, data }. Cada mudança de requestKey busca de novo; a resposta de um filtro
// antigo é descartada. O dado anterior fica na tela (esmaecido) até chegar o novo. 403: a aba foi retirada
export function useDashboardBlock(requestKey, load, onForbidden) {
  const [state, setState] = useState({ loading: true, error: '', data: null })
  const requestRef = useRef(0)
  const loadRef = useRef(load)
  const forbiddenRef = useRef(onForbidden)
  loadRef.current = load
  forbiddenRef.current = onForbidden

  const run = useCallback(() => {
    const requestId = ++requestRef.current
    setState((current) => ({ ...current, loading: true, error: '' }))

    loadRef.current()
      .then(({ data }) => {
        if (requestId !== requestRef.current) return
        setState({ loading: false, error: '', data })
      })
      .catch((error) => {
        if (requestId !== requestRef.current) return
        if (isForbidden(error)) forbiddenRef.current?.()
        setState((current) => ({ ...current, loading: false, error: errorMessage(error) }))
      })
  }, [])

  useEffect(() => {
    if (requestKey !== null) run()
  }, [requestKey, run])

  return { ...state, reload: run }
}

// Celular (até 576 px): rótulos do eixo mais espaçados
export function useIsNarrow(query = '(max-width: 576px)') {
  const [narrow, setNarrow] = useState(() => window.matchMedia?.(query).matches ?? false)

  useEffect(() => {
    const media = window.matchMedia?.(query)
    if (!media) return
    const update = () => setNarrow(media.matches)
    update()
    media.addEventListener('change', update)
    return () => media.removeEventListener('change', update)
  }, [query])

  return narrow
}
